import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import '../CSS/Guests.css';
import { getCampers, getGuestDetails, deleteCamper, createnewCamper } from '../utils/OpenCampground_Database_Calls';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import { Select, MenuItem, TextField, Checkbox, FormControlLabel } from '@mui/material';
import guests from '../assets/guests.png'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import GuestDetail from './GuestDetail';
import exportIcon from '../assets/export.png'
import { ThirtyFpsSelectSharp } from '@mui/icons-material';

const useStyles = theme => ({
    circularProgress: {
        position: 'absolute',
        left: '55%',
        top: '50%',
        color: '#2dcd7a'
    }
});

const numericFields = new Set(['mail_code', 'reservation_count']);

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});
class Guests extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allGuests: [],
            guests: [],
            currentPage: 1,
            searchValue: '',
            searchType: 'fname',
            noGuests: false,
            guestDetail: false,
            individualGuestDetails: [],
            open: false,
            popupText: '',
            popupTitle: '',
            noPastGuests: '',
            sortConfig: {
                key: null,
                direction: 'asc'
            },
            open: false,
            popupTitle: '',
            popupText: '',
            camperToHandle: '',
            confirmationOpen: false,
            confirmationTitel: 'confirmationTitel',
            confirmationText: 'confirmationText',
            addNew: false,
            formValid: false,
            guest: null,
            noReservations: false
        };
    }

    async componentDidMount() {
        this.getGuests()
    }

    getGuests = async () => {
        let listOfGuests = await getCampers(this.props.user, this.props.serverName);
        this.setState({
            allGuests: listOfGuests,
            guests: listOfGuests,
            noPastGuests: listOfGuests.length === 0
        })
    }

    openPopup = async (camper) => {
        console.log(camper)
        let popupText = "Proceed with Delete for " + camper.first_name + " " + camper.last_name+".";
        let popupTitel = "Confirm Delete";
        if(camper.has_active_reservation){
            let confirmationTitel = ""
            let confirmationText = "Can't delete " + camper.first_name +" "+ camper.last_name+" because of active reservations.";
            this.setState({
                confirmationOpen: true,
                confirmationTitel: confirmationTitel,
                confirmationText: confirmationText
            });
            return;
        }

        this.setState({
            open: true,
            popupTitle: popupTitel,
            popupText: popupText,
            camperToHandle: camper,
        });
    }

    handleConfirm = async () => {
        const { camperToHandle } = this.state;
        let confirmationText = '';
        let confirmationTitel = '';
        await deleteCamper(this.props.user, this.props.serverName, camperToHandle.id);
        this.setState({ confirm: true, open: false });               
        confirmationTitel = "Guest Deleted"
        confirmationText = "Guest Name: " + camperToHandle.first_name + camperToHandle.last_name+".";
        // this.setState({
            
        // })
        this.setState({
            confirmationOpen: true,
            confirmationTitel: confirmationTitel,
            confirmationText: confirmationText,
            guests: [],
        });
        this.getGuests();
    };

    handleCancel = () => {
        this.setState({ confirm: false, open: false });
        console.log("canceled");
    };

    getGuestsByName = async (value) => {
        let filteredGuests = this.state.allGuests.filter(guest => {
        const searchValue = value.toLowerCase();
            return (
                (guest.first_name && guest.first_name?.toLowerCase()?.includes(searchValue)) ||
                (guest.last_name && guest.last_name?.toLowerCase()?.includes(searchValue)) ||
                (guest.email && guest.email.toString()?.includes(searchValue)) ||
                (guest.city && guest.city.toLowerCase()?.includes(searchValue)) ||
                (guest.address && guest.address.toString()?.includes(searchValue)) ||
                (guest.mail_code && guest.mail_code.toString()?.includes(searchValue)) ||
                (guest.phone && guest.phone.toString()?.includes(searchValue)) ||
                ((guest.first_name && guest.last_name) && (`${guest?.first_name?.toLowerCase()} ${guest?.last_name.toLowerCase()}`)?.includes(searchValue))
            );
        }
        );
        if (filteredGuests.length < 1) {
            this.setState({
                value: '',
                noGuests: true,
            });
        } else {
            this.setState({
                value: '',
                guests: filteredGuests,
                noGuests: false
            });
        }
    }

    exportToCSV = () => {
        const data = this.state.guests;
        if (!data || data.length === 0) {
            alert("No data available to export.");
            return;
        }

        const headers = Object.keys(data[0])
        .filter((key, index) => index !== 9 && index !== 10 && index !== 12)
        .join(',')+'\n';
        console.log(headers);

        const csvRows = data.map(row =>
            Object.values(row)
                .filter((value, index) => index !== 9 && index !== 10 && index !== 12)
                .map(value => `"${value}"`)
                .join(',')+'\n'
        );

        const csvString = headers + csvRows.join('\n');

        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'exported_data.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    addNew = async () => {
        let createNewRigTypeResponse = await createnewCamper(this.props.user, this.props.serverName, this.state.guest.name, this.state.guest.lastName, this.state.guest.email, this.state.guest.phone||"", this.state.guest.address||"", this.state.guest.city||"", this.state.guest.state||"", this.state.guest.postal||"");
        this.setState({
            rigTypesUpdate: true,
            addNew: false,
            confirmationOpen: true,
            confirmationTitel: 'Guest Added',
            confirmationText:'Success! Guest profile has been created.',
            editingRigType: null,
        });
        this.getGuests();
    }

    handleChange = (event,field) => {
        console.log(field, this.state.guest);

        this.setState({
            guest: { ...this.state.guest, [field]: event.target.value }
        }, () => {
            this.formValidation();
        });
    }

    formValidation = () => {
        if (this.state.guest.name && this.state.guest.email) {
            this.setState({
                formValid: true
            });
        } else if (this.state.formValid) {
            this.setState({
                formValid: false
            });
        }
    }

    getGuestsByEmail = async (value) => {
        let filteredGuests = this.state.allGuests.filter(guest =>
            guest.email && guest.email.toLowerCase() === value.toLowerCase()
        );
        if (filteredGuests.length < 1) {
            this.setState({
                value: '',
                noGuests: true,
            });
        } else {
            this.setState({
                value: '',
                guests: filteredGuests,
                noGuests: false
            });
        }
    }

    displayAllReservations = async () => {
        this.setState({
            noGuests: false,
            guests: this.state.allGuests
        })
    }

    backToGuest = () => {
        this.getGuests();
        this.setState({ guestDetail: false })
    }

    guestDetails = async (item) => {
        if(!item.reservation_count){
            this.setState({
                individualGuestDetails: [{
                    "reservationID": null,
                    "camperId": item.id,
                    "first_name": item.first_name,
                    "last_name": item.last_name,
                    "phone": item.phone,
                    "email": item.email,
                    "address": item.address,
                    "city": item.city,
                    "state": item.state,
                    "mail_code": item.mail_code,
                    "notes": item.notes,
                }],
                guestDetail: true,
                noReservations: true
            })
        }
        else{
            let guestDetails = await getGuestDetails(this.props.user, this.props.serverName, item.id)
            console.log(guestDetails.body)
            if (guestDetails.body.length > 0) {
                this.setState({
                individualGuestDetails: guestDetails.body,
                guestDetail: true,
                noReservations: false })
            } else {
            this.setState({
                confirmationOpen: true,
                confirmationTitel: 'Alert',
                confirmationText: 'No further details are available.' })
            }
        }
    }
    handleSort = (columnKey) => {
        this.setState((prevState) => {
          const { sortConfig } = prevState;
          if (sortConfig.key === columnKey) {
            if (sortConfig.direction === 'asc') {
              return { sortConfig: { key: columnKey, direction: 'desc' } };
            } else if (sortConfig.direction === 'desc') {
              // Reset sort
              return { sortConfig: { key: null, direction: null } };
            }
          }
          return { sortConfig: { key: columnKey, direction: 'asc' } };
        });
    };

    render() {
        const { classes } = this.props;
        const itemsPerPage = 15;

        const totalPages = Math.ceil(this.state.guests.length / itemsPerPage);
        let currentPage = this.state.currentPage || 1;

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, this.state.guests.length);

        const reservationsOnPage = this.state.guests.slice(startIndex, endIndex);
        function formatPhoneNumber(phone) {
            if (!phone) return '';
            const cleaned = phone.replace(/\D/g, '');
            if (cleaned.length === 10) {
                return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
            }
            return phone;
        }
        let sortedGuests = this.state.guests.slice(startIndex, endIndex);
        const { key, direction } = this.state.sortConfig;
        if (key && direction) {
            sortedGuests.sort((a, b) => {
                let valA = a[key];
                let valB = b[key];
                const isNumeric = numericFields.has(key);
                const normalizePhone = (phone) => phone?.replace(/\D/g, '') || '';
                if (isNumeric) {
                    valA = parseFloat(valA)??0;
                    valB = parseFloat(valB)??0;
                } else {
                    if(key=="phone"){
                    valA = normalizePhone(valA);
                    valB = normalizePhone(valB);
                    }
                    else{
                    valA = valA?.toLowerCase() || '';
                    valB = valB?.toLowerCase() || '';
                    }
                }
                if (valA < valB) return direction === 'asc' ? -1 : 1;
                if (valA > valB) return direction === 'asc' ? 1 : -1;
                return 0;
            });
        }

        let guestsRows = sortedGuests.map((item) => {
            return (
                <tr key={item.id} className='rows'>
                    <td>{item.first_name} {item.last_name}</td>
                    <td>{item.address}</td>
                    <td>{item.city}</td>
                    <td>{item.mail_code}</td>
                    <td>{formatPhoneNumber(item.phone)}</td>
                    <td>{item.email}</td>
                    <td>{item.reservation_count}</td>
                    <td style={{display:"flex", flexDirection:"column"}}>
                        <Button
                            onClick={() => this.guestDetails(item)}
                            style={{ backgroundColor: '#d4d4d4', color: 'black', padding: '2% 10% 2% 10%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                        >
                            View
                        </Button>
                        <Button
                        className='selectButton'
                        onClick={() => this.openPopup(item)}
                        style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                        >
                        Delete
                        </Button>
                    </td>
                </tr>
            );
        });

        const paginationButtons = [];
        const maxButtonsToShow = 10;
        let startPage, endPage;

        if (totalPages <= maxButtonsToShow) {
            startPage = 1;
            endPage = totalPages;
        } else {
            const maxPagesBeforeCurrentPage = Math.floor(maxButtonsToShow / 2);
            const maxPagesAfterCurrentPage = Math.ceil(maxButtonsToShow / 2) - 1;
            if (currentPage <= maxPagesBeforeCurrentPage) {
                startPage = 1;
                endPage = maxButtonsToShow;
            } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
                startPage = totalPages - maxButtonsToShow + 1;
                endPage = totalPages;
            } else {
                startPage = currentPage - maxPagesBeforeCurrentPage;
                endPage = currentPage + maxPagesAfterCurrentPage;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            paginationButtons.push(
                <Button className={`paginationButton ${currentPage === i ? "activePage" : ""}`} key={i} onClick={() => this.setState({ currentPage: i })}>
                    {i}
                </Button>
            );
        }

        const previousButton = (
            <Button className='previousButton' disabled={currentPage === 1} onClick={() => this.setState({ currentPage: currentPage - 1 })}>
                <ArrowBackIosIcon />
            </Button>
        );

        const nextButton = (
            <Button className='nextButton' disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: currentPage + 1 })}>
                <ArrowForwardIosIcon />
            </Button>
        );

        const lastButton = (
            <Button className='paginationButton' disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: totalPages })}>
                {totalPages}
            </Button>
        );

        if (this.state.guestDetail) {
            return <Grid className='guestsList'>
                <ThemeProvider theme={theme}>
                    <Box className='infoBox'>
                        <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                        <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                    </Box>
                    <div className='box' style={{ padding: "0px 3%" }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={guests} alt="Guests" style={{ height: '40px', width: '40px' }} />
                            <p className='transactionstypography' style={{ whiteSpace: "nowrap", margin: "0px", marginLeft: '10%' }}>Guest Details</p>
                        </div>
                    </div>
                    <GuestDetail backToGuest={this.backToGuest} individualGuestDetails={this.state.individualGuestDetails} serverName={this.props.serverName} user={this.props.user} noReservations={this.state.noReservations} />
                </ThemeProvider>
            </Grid>
        }
        else {
            if (this.state.guests.length >= 1 || this.state.noGuests) {
                return (
                    <Grid className='guestsList'>
                        <ThemeProvider theme={theme}>
                            <Dialog open={this.state.confirmationOpen} onClose={()=>this.setState({confirmationOpen:false})} classes={{ paper: classes.dialogPaper }}>
                                <DialogTitle>{this.state.confirmationTitel}</DialogTitle>
                                <DialogContent>
                                    {this.state.confirmationText}
                                </DialogContent>
                                <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Button onClick={() => this.setState({ confirmationOpen: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                        Close
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={this.state.open} onClose={this.handleCancel} classes={{ paper: classes.dialogPaper }}>
                                <DialogTitle>{this.state.popupTitle}</DialogTitle>
                                <DialogContent>
                                    {this.state.popupText}
                                </DialogContent>
                                <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Button onClick={this.handleCancel} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                        Cancel
                                    </Button>
                                    <Button onClick={this.handleConfirm} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                        Confirm
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            <Box className='infoBox'>
                                <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                                <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                            </Box>
                            <Box className='box'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <img src={guests} alt="Guests" style={{ height: '40px', width: '40px' }} />
                                    <Typography className='transactionstypography' >Guests</Typography>
                                    <p style={{margin:'0', marginLeft:'5px', width:"110px"}}>{`(Total ${this.state.guests.length})`}</p>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4%', width:'50%' }}>
                                    {this.state.searchType === "fname"
                                        ?
                                        <>
                                            <SearchBar
                                                className='searchBox'
                                                placeholder='e.g. name, address, city, postal code, email, phone'
                                                style={{width:'100%'}}
                                                value={this.state.searchValue}
                                                onChange={(newValue) => this.setState({ searchValue: newValue })}
                                                onRequestSearch={() => this.getGuestsByName(this.state.searchValue)}
                                                cancelOnEscape={true}
                                                onCancelSearch={() => this.displayAllReservations()}
                                            />
                                        </>
                                        :
                                        <>
                                            <SearchBar
                                                className='searchBox'
                                                placeholder='Search By Email'
                                                value={this.state.searchValue}
                                                onChange={(newValue) => this.setState({ searchValue: newValue })}
                                                onRequestSearch={() => this.getGuestsByEmail(this.state.searchValue)}
                                                cancelOnEscape={true}
                                                onCancelSearch={() => this.displayAllReservations()}
                                            />
                                        </>
                                    }
                                </div>
                            </Box>
                            <div style={{ display: 'flex', marginRight: '2%', alignItems: 'center', justifyContent:'flex-end', marginBottom:'1%' }}>
                            <Button className='button' onClick={this.exportToCSV}>
                                <img src={exportIcon} alt="NewReservations" className='buttonImage' style={{height:'24px', width:'24px'}} />
                                <span className='activePaymentOption'>Export Data</span>
                            </Button>
                            {/* <Button className='resButton' onClick={() => { this.setState({ addNew: true }) }} style={{ backgroundColor: '#2dcd7a', color: '#000000', textTransform: "capitalize" }}>Add New Guest</Button> */}
                            {this.state.addNew
                            ?
                            <Dialog open={this.state.addNew || this.state.editingIndex >= 0} onClose={() => {this.setState({addNew: false,})}} maxWidth="sm" fullWidth>
                            <DialogContent dividers>
                                <div>
                                    <h2 style={{ margin: "0px", marginBottom: "26px" }}>Add New Guest</h2>
                                </div>
                                <div style={{ display:'grid', alignItems: 'center', gap: '4%', gridTemplateColumns: '240px 240px' }}>
                                    <TextField id="name" required label="First Name"
                                        value={this.state?.editingRigType?.name}
                                        onChange={(event) => this.handleChange(event, 'name')} />
                                    <TextField id="lname" required label="Last Name"
                                        value={this.state?.editingRigType?.lastName}
                                        onChange={(event) => this.handleChange(event, 'lastName')} />
                                    <TextField id="address" label="Address"
                                        value={this.state?.editingRigType?.address}
                                        onChange={(event) => this.handleChange(event, 'address')} />
                                    <TextField id="city" label="City"
                                        value={this.state?.editingRigType?.city}
                                        onChange={(event) => this.handleChange(event, 'city')} />
                                    <TextField id="city" label="State"
                                        value={this.state?.editingRigType?.state}
                                        onChange={(event) => this.handleChange(event, 'state')} />
                                    <TextField id="postal" label="Postal Code"
                                        value={this.state?.editingRigType?.postal}
                                        onChange={(event) => this.handleChange(event, 'postal')} />
                                    <TextField id="phone" label="Phone"
                                        value={this.state?.editingRigType?.phone}
                                        onChange={(event) => this.handleChange(event, 'phone')} />
                                    <TextField id="email" required label="Email"
                                        value={this.state?.editingRigType?.email}
                                        onChange={(event) => this.handleChange(event, 'email')} />
                                    <Button style={{ backgroundColor: '#2dcd7a', color: '#000000', marginBottom:'40px' }} onClick={this.addNew} disabled={!this.state.formValid}>Add Guest</Button>
                                    <Button style={{ backgroundColor: '#FDECEB', color: '#DB3737', marginBottom:'40px' }} onClick={() => { this.setState({ addNew: false, guest: null }) }}>Cancel</Button>
                                </div>
                            </DialogContent>
                            </Dialog>
                            : ""}
                            </div>
                        </ThemeProvider>

                        {/* <Box className='tableheadingbox'>
                            <Typography className='headerTypo'>Customer Name</Typography>
                            <Typography className='headerTypo'>Address</Typography>
                            <Typography className='headerTypo'>City</Typography>
                            <Typography className='headerTypo'>Postal Code</Typography>
                            <Typography className='headerTypo'>Phone</Typography>
                            <Typography className='headerTypo'>Email</Typography>
                            <Typography className='headerTypo'>Details</Typography>
                        </Box> */}
                        <Box className='tableheadingbox'>
                            {[
                                { key: 'first_name', label: 'Customer Name' },
                                { key: 'address', label: 'Address' },
                                { key: 'city', label: 'City' },
                                { key: 'mail_code', label: 'Postal Code' },
                                { key: 'phone', label: 'Phone' },
                                { key: 'email', label: 'Email' },
                                { key: 'reservation_count', label: 'Reservations' },
                            ].map((col) => (
                            <Typography
                            key={col.key}
                            className='headerTypo'
                            onClick={() => this.handleSort(col.key)}
                            style={{ cursor: 'pointer', position: 'relative' }}
                            >
                                {col.label}
                                {this.state.sortConfig.key === col.key ? (
                            <>
                            {this.state.sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽'}
                            </>
                        ) : ''}
                        </Typography>))}
                        <Typography className='headerTypo'>Details</Typography>
                        </Box>
                        {!this.state.noGuests
                            ?
                            <>
                                <Box className='tableBox'>
                                    <table>
                                        <tbody>
                                            {guestsRows}
                                        </tbody>
                                    </table>
                                </Box>
                                <div className="pagination">
                                    {previousButton}
                                    {paginationButtons}
                                    ...
                                    {lastButton}
                                    {nextButton}
                                </div>
                            </>
                            :
                            <>
                                <Typography className='headerTypo'>No Transactions Found</Typography>
                            </>
                        }
                    </Grid >
                );
            } else if (this.state.noPastGuests) {
                return (
                    <Grid className='transactionsList'>
                        <Box className='infoBox'>
                            <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                            <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                        </Box>
                        <Box className='box'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={guests} alt="Guests" style={{ height: '40px', width: '40px' }} />
                                <Typography className='transactionstypography' >Guests</Typography>
                            </div>
                        </Box>
                        <Typography style={{ marginTop: '2%', fontSize: '1.5rem' }}> You do not have any past guests.</Typography>
                    </Grid>
                );
            } else {
                return (
                    <CircularProgress className={classes.circularProgress} />
                );
            }
        }
    };
};

export default withStyles(useStyles)(Guests);